import {createGlobalState} from 'react-hooks-global-state';

// Global state ---
export interface GlobalStateType {
  accessToken: string;
  viewKey: string;
}

const {useGlobalState, getGlobalState} = createGlobalState<GlobalStateType>({
  accessToken: null,
  viewKey: null,
});

// can be used outside React (e.g. in axios headers)
export const getGlobalAccessToken = () => getGlobalState('accessToken');
export const getGlobalViewKey = () => getGlobalState('viewKey');

export {useGlobalState, getGlobalState};
